"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  id: 1,
  quote: "\"Grâce à Poire Com, notre visibilité locale a considérablement augmenté en quelques mois.\"",
  author: "Sophie M.",
  position: "Propriétaire d'une boutique locale",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1534050/img/sophie_m_business_logo.png"
}, {
  id: 2,
  quote: "Une équipe transparente, à l'écoute, et des résultats concrets en référencement IA.",
  author: "Marc D.",
  position: "Indépendant",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1534050/img/marc_d_business_logo.png"
}];
export default function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="témoignages-clients" ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h2 className="text-3xl font-bold sm:text-4xl lg:text-5xl">
            Témoignages clients
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Découvrez ce que nos clients disent de nos services
          </p>
        </div>

        <div className="relative px-12">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                  <div className="p-1">
                    <Card className={`card mx-auto max-w-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
                  transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
                }}>
                      <CardHeader className="items-center text-center">
                        <div className="mb-4">
                          <img src={testimonial.logo} alt={`Logo de ${testimonial.author}`} className="mx-auto h-16 w-auto object-contain" />
                        </div>
                        <CardDescription className="text-base italic sm:text-lg">
                          "{testimonial.quote}"
                        </CardDescription>
                      </CardHeader>
                      <CardContent className="text-center">
                        <CardTitle className="mb-1 text-lg">
                          {testimonial.author}
                        </CardTitle>
                        <p className="text-muted-foreground text-sm">
                          {testimonial.position}
                        </p>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hover-lift focus-ring" />
            <CarouselNext className="hover-lift focus-ring" />
          </Carousel>
        </div>
      </div>
    </section>;
}